import React, {useState, useContext} from "react";
import {
  Grid,
  Typography,
  Box,
  Card,
  CardContent,
  Link,
  TextField,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { SearchIcon } from "../../assets/icons/icons";
import { adminCategories } from "./adminCategories";
import { LanguageContext } from "../../context/languageContext";

export default function AdminDashboard() {
  const { translations, language, changeLanguage } =
    useContext(LanguageContext);

  // State Variables
  const [searchTerm, setSearchTerm] = useState("");

  // Handler for search input change
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
  };

  // Filtered categories based on search term
  const filteredCategories = adminCategories.map((category) => ({
    ...category,
    subcategories: category.subcategories.filter((subcat) =>
      subcat.text.toLowerCase().includes(searchTerm)
    ),
  }));

  return (
    <>
      <Box
        sx={{
          backgroundColor: "var(--reach-blue)",
          height: "35px",
          display: "flex",
          alignItems: "center",
          justifyContent: "left",
        }}
      >
        <Typography
          sx={{
            fontFamily: "BrightstarSans-Bold",
            color: "var(--dust-white)",
            ml: 2,
          }}
        >
          {translations.adminPanel || "Admin Panel"}
        </Typography>
      </Box>
      <TextField
        size="small"
        label="Search"
        variant="outlined"
        sx={{
          backgroundColor: "white",
          borderRadius: "5px",
          width: "93.5%",
          mb: "20px",
          mt: "20px",
          ml: "50px",
        }}
        value={searchTerm}
        onChange={handleSearchChange}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <Grid
        container
        spacing={2}
        style={{ marginLeft: "50px", marginRight: "50px", marginTop: "20px" }}
      >
        {filteredCategories.map((category) => (
          <Grid size={4} key={category.title}>
            <Card
              variant="outlined"
              sx={{
                minHeight: "100%",
                maxWidth: "100%",
                backgroundColor: "var(--dust-white)",
              }}
            >
              <CardContent>
                <Typography
                  sx={{
                    borderBottom: "3px solid black",
                    display: "flex",
                    justifyContent: "center",
                    fontFamily: "BrightstarSans-Bold",
                  }}
                >
                  {category.title}
                </Typography>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    margin: "10px",
                  }}
                >
                  {category.subcategories.length > 0 ? (
                    category.subcategories.map((subcat) => (
                      <Link
                        href={subcat.link}
                        variant="button"
                        sx={{
                          textDecoration: "none",
                          fontSize: "15px",
                          color: "var(--vega-blue)",
                          fontFamily: "BrightstarSans-Regular",
                        }}
                      >
                        {subcat.text}
                      </Link>
                    ))
                  ) : (
                    <Typography variant="body2">
                      No matching subcategories
                    </Typography>
                  )}
                </div>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
// Categories and subcategories data
